<template>
    <div class="tw-inline">
        <i class="fal fa-poll-h" @click="startPollMaking"></i>
    </div>
</template>

<script>
    export default {
        methods: {
            startPollMaking() {
                this.$store.commit('togglePollCreation', true);
                $('.topic-creation').hide();
                $('.topic-options').hide();
            }
        }
    }
</script>